// client/src/components/LoginForm.js

import React from "react";
import { Form, Button, Container } from "react-bootstrap"; // ✅ Added Container
import { Link } from "react-router-dom"; // ✅ Added Link

const LoginForm = ({ onSubmit, email, password, setEmail, setPassword }) => {
    return (
        <Container className="mt-5 col-4 shadow p-3">
            <Form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
                <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email"
                        required
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password"
                        required
                    />
                </Form.Group>

                <Button variant="primary" type="submit">Login</Button>
            </Form>

            <div className="text-center mt-3">
                <p>
                    Don't have an account? <Link to="/signup">Create one</Link>
                </p>
            </div>
        </Container>
    );
};

export default LoginForm;
